import { defineComponent, inject, PropType, ref } from 'vue';
import SButton from '@/components/stemdo-components/s-button/SButton.vue';
import SModalCentered from '@/components/stemdo-components/s-modal-centered/SModalCentered.vue';
import { TeamRequest } from '@/shared/model/team-request.model';
import { ButtonGroupModals } from '../../../buttonsGroup';

export default defineComponent({
  props: {
    teamRequest: {
      type: Object as () => TeamRequest,
      required: true
    },
    refreshTeamRequest: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onOpenModal: {
      type: Function,
      required: true
    }
  },
  components: {
    SButton,
    SModalCentered
  },
  setup(props) {
    const sendProposal = () => {
      props.onOpenModal(ButtonGroupModals.NEW_PROPOSAL);
    };

    const approveRequest = () => {
      props.onOpenModal(ButtonGroupModals.TR_APPROVED_BY_MANAGER);
    };

    const cancelRequest = () => {
      props.onOpenModal(ButtonGroupModals.TR_CANCELLED);
    };

    return {
      sendProposal,
      approveRequest,
      cancelRequest
    };
  }
});
